<div>
    <div *ngIf="!isCreateContract && !isChooseContract">
        <mat-tab-group  (selectedTabChange)="tabClick($event)">
            <mat-tab label="{{'submitContract'|translate}}">
                <app-submit-contract [AllClients]="AllClients" (selectedClient)="GetSelectedClient($event)"
                    (createContract)="CheckIfCreateContract($event)"></app-submit-contract>
            </mat-tab>

            <mat-tab label="{{'submitWarranty'|translate}}">
                <app-submit-warranty [ContractsList]="ContractsList" (selectedContract)="GetSelectedContract($event)"
                (chooseContract)="CheckIfChooseContract($event)"></app-submit-warranty>
            </mat-tab>
        </mat-tab-group>
    </div>

    <div *ngIf="isCreateContract">
        <app-create-contract [Client]="selectedClient"
            (createContract)="CheckIfCreateContract($event)"></app-create-contract>
    </div>

    <div *ngIf="isChooseContract">
        <app-choose-contract  [Contract]="selectedContract" 
        (chooseContract)="CheckIfChooseContract($event)"></app-choose-contract>
    </div>
</div>